import { errorNotificationWrapper } from '../../../logic/helpers/NotificationService'
import BonusApi from '../Api/BonusApi'
import { BonusHistoryRequest } from '../includes/types/BonusHistory'

export const getBonusInfo = async () => {
  return BonusApi.getBonusInfo()
    .then(({ data }) => data)
    .catch((error) => errorNotificationWrapper('Error', error))
}

export const getBonusHistory = async <T>(
  type: BonusHistoryRequest['type'],
  offset: BonusHistoryRequest['offset'],
  limit: BonusHistoryRequest['limit']
) => {
  return BonusApi.getBonusHistory<T>({ type, offset, limit })
    .then(({ data }) => data)
    .catch((error) => errorNotificationWrapper("Error", error))
}

